module.exports = __webpack_public_path__ + "bb8e3876755882b0322d11c9cd563610.png";